// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/images/Home.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/images/about-u.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/images/Image-Pop.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/images/FAQ-Page.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/assets/images/Need-Help.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/assets/images/bg-getstarted.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.2 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #eeeeee; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Roboto, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #bdbdbd; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.\\!invisible {
  visibility: hidden !important;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.-left-1 {
  left: -0.25rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-2\\.5 {
  top: -0.625rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-\\[14\\%\\] {
  bottom: 14%;
}
.bottom-\\[4\\%\\] {
  bottom: 4%;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2\\/4 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[14\\%\\] {
  left: 14%;
}
.left-\\[2\\%\\] {
  left: 2%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-\\[14\\%\\] {
  right: 14%;
}
.right-\\[2\\%\\] {
  right: 2%;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-16 {
  top: 4rem;
}
.top-2\\/4 {
  top: 50%;
}
.top-3 {
  top: 0.75rem;
}
.top-80 {
  top: 20rem;
}
.top-\\[14\\%\\] {
  top: 14%;
}
.top-\\[4\\%\\] {
  top: 4%;
}
.-z-10 {
  z-index: -10;
}
.-z-50 {
  z-index: -50;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[-10\\] {
  z-index: -10;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[20\\] {
  z-index: 20;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[9995\\] {
  z-index: 9995;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.-m-6 {
  margin: -1.5rem;
}
.m-0 {
  margin: 0px;
}
.m-0\\.5 {
  margin: 0.125rem;
}
.m-4 {
  margin: 1rem;
}
.m-auto {
  margin: auto;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mx-px {
  margin-left: 1px;
  margin-right: 1px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-1 {
  margin-bottom: -0.25rem;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-32 {
  margin-left: -8rem;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mt-10 {
  margin-top: -2.5rem;
}
.-mt-16 {
  margin-top: -4rem;
}
.-mt-20 {
  margin-top: -5rem;
}
.-mt-48 {
  margin-top: -12rem;
}
.-mt-6 {
  margin-top: -1.5rem;
}
.-mt-px {
  margin-top: -1px;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-80 {
  margin-bottom: 20rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-\\[18px\\] {
  margin-left: 18px;
}
.ml-auto {
  margin-left: auto;
}
.mr-12 {
  margin-right: 3rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-\\[-1\\.00px\\] {
  margin-top: -1.00px;
}
.mt-px {
  margin-top: 1px;
}
.box-border {
  box-sizing: border-box;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 1.5px;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[110px\\] {
  height: 110px;
}
.h-\\[185px\\] {
  height: 185px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[203px\\] {
  height: 203px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[380px\\] {
  height: 380px;
}
.h-\\[40vh\\] {
  height: 40vh;
}
.h-\\[450px\\] {
  height: 450px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[58px\\] {
  height: 58px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[74px\\] {
  height: 74px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-max {
  height: max-content;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[100vh\\] {
  max-height: 100vh;
}
.max-h-\\[32px\\] {
  max-height: 32px;
}
.max-h-\\[40px\\] {
  max-height: 40px;
}
.max-h-\\[48px\\] {
  max-height: 48px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[95px\\] {
  max-height: 95px;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[100vh\\] {
  min-height: 100vh;
}
.min-h-\\[12px\\] {
  min-height: 12px;
}
.min-h-\\[24px\\] {
  min-height: 24px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-2\\/5 {
  width: 40%;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-3\\/5 {
  width: 60%;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[175px\\] {
  width: 175px;
}
.w-\\[203px\\] {
  width: 203px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[58px\\] {
  width: 58px;
}
.w-\\[74px\\] {
  width: 74px;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-screen {
  width: 100vw;
}
.min-w-\\[100vw\\] {
  min-width: 100vw;
}
.min-w-\\[12px\\] {
  min-width: 12px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[48px\\] {
  min-width: 48px;
}
.min-w-\\[80\\%\\] {
  min-width: 80%;
}
.min-w-\\[90\\%\\] {
  min-width: 90%;
}
.min-w-\\[95\\%\\] {
  min-width: 95%;
}
.max-w-\\[100vw\\] {
  max-width: 100vw;
}
.max-w-\\[1204px\\] {
  max-width: 1204px;
}
.max-w-\\[134px\\] {
  max-width: 134px;
}
.max-w-\\[32px\\] {
  max-width: 32px;
}
.max-w-\\[40px\\] {
  max-width: 40px;
}
.max-w-\\[450px\\] {
  max-width: 450px;
}
.max-w-\\[48px\\] {
  max-width: 48px;
}
.max-w-\\[540px\\] {
  max-width: 540px;
}
.max-w-\\[550px\\] {
  max-width: 550px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[610px\\] {
  max-width: 610px;
}
.max-w-\\[700px\\] {
  max-width: 700px;
}
.max-w-\\[750px\\] {
  max-width: 750px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[850px\\] {
  max-width: 850px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[95\\%\\] {
  max-width: 95%;
}
.max-w-full {
  max-width: 100%;
}
.max-w-screen-2xl {
  max-width: 1536px;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.basis-full {
  flex-basis: 100%;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2\\/4 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/4 {
  --tw-translate-y: -25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2\\/4 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2\\/4 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-50 {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0 {
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-100 {
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.\\!resize-none {
  resize: none !important;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.\\!resize {
  resize: both !important;
}
.resize {
  resize: both;
}
.appearance-none {
  appearance: none;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-rows-1 {
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-9 {
  gap: 2.25rem;
}
.gap-\\[4px\\] {
  gap: 4px;
}
.gap-x-20 {
  column-gap: 5rem;
}
.gap-y-10 {
  row-gap: 2.5rem;
}
.gap-y-12 {
  row-gap: 3rem;
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-amber-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(255 179 0 / var(--tw-divide-opacity));
}
.divide-blue-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(30 136 229 / var(--tw-divide-opacity));
}
.divide-blue-gray-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-divide-opacity));
}
.divide-blue-gray-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(84 110 122 / var(--tw-divide-opacity));
}
.divide-brown-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(109 76 65 / var(--tw-divide-opacity));
}
.divide-cyan-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(0 172 193 / var(--tw-divide-opacity));
}
.divide-deep-orange-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(244 81 30 / var(--tw-divide-opacity));
}
.divide-deep-purple-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(94 53 177 / var(--tw-divide-opacity));
}
.divide-gray-800 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(66 66 66 / var(--tw-divide-opacity));
}
.divide-green-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(67 160 71 / var(--tw-divide-opacity));
}
.divide-indigo-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(57 73 171 / var(--tw-divide-opacity));
}
.divide-light-blue-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(3 155 229 / var(--tw-divide-opacity));
}
.divide-light-green-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(124 179 66 / var(--tw-divide-opacity));
}
.divide-lime-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(192 202 51 / var(--tw-divide-opacity));
}
.divide-orange-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(251 140 0 / var(--tw-divide-opacity));
}
.divide-pink-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(216 27 96 / var(--tw-divide-opacity));
}
.divide-purple-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(142 36 170 / var(--tw-divide-opacity));
}
.divide-red-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 57 53 / var(--tw-divide-opacity));
}
.divide-teal-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(0 137 123 / var(--tw-divide-opacity));
}
.divide-yellow-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(253 216 53 / var(--tw-divide-opacity));
}
.self-stretch {
  align-self: stretch;
}
.justify-self-end {
  justify-self: end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.\\!overflow-visible {
  overflow: visible !important;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[40px\\] {
  border-radius: 40px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-\\[40px\\] {
  border-bottom-right-radius: 40px;
  border-bottom-left-radius: 40px;
}
.rounded-l-2xl {
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t-\\[40px\\] {
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-solid {
  border-style: solid;
}
.border-none {
  border-style: none;
}
.border-\\[\\#45115f4c\\] {
  border-color: #45115f4c;
}
.border-\\[\\#45115f\\] {
  --tw-border-opacity: 1;
  border-color: rgb(69 17 95 / var(--tw-border-opacity));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.border-blue-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-blue-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.border-blue-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}
.border-blue-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.border-brown-500 {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.border-deep-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.border-deep-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.border-light-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.border-light-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.border-main {
  --tw-border-opacity: 1;
  border-color: rgb(69 17 95 / var(--tw-border-opacity));
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-white\\/80 {
  border-color: rgb(255 255 255 / 0.8);
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.\\!border-t-transparent {
  border-top-color: transparent !important;
}
.border-b-\\[\\#f0eaf3\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(240 234 243 / var(--tw-border-opacity));
}
.border-b-blue-gray-100 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-blue-gray-100 {
  --tw-border-opacity: 1;
  border-top-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[\\#EEE7F0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 231 240 / var(--tw-bg-opacity));
}
.bg-\\[\\#F8EBC6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 235 198 / var(--tw-bg-opacity));
}
.bg-\\[\\#FCF6FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 246 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#eee7f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 231 240 / var(--tw-bg-opacity));
}
.bg-\\[\\#ffffff66\\] {
  background-color: #ffffff66;
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.bg-amber-500\\/10 {
  background-color: rgb(255 193 7 / 0.1);
}
.bg-amber-500\\/20 {
  background-color: rgb(255 193 7 / 0.2);
}
.bg-background {
  --tw-bg-opacity: 1;
  background-color: rgb(251 251 253 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.bg-blue-500\\/10 {
  background-color: rgb(33 150 243 / 0.1);
}
.bg-blue-500\\/20 {
  background-color: rgb(33 150 243 / 0.2);
}
.bg-blue-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}
.bg-blue-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.bg-blue-gray-50\\/50 {
  background-color: rgb(236 239 241 / 0.5);
}
.bg-blue-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.bg-blue-gray-500\\/10 {
  background-color: rgb(96 125 139 / 0.1);
}
.bg-blue-gray-500\\/20 {
  background-color: rgb(96 125 139 / 0.2);
}
.bg-brown-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.bg-brown-500\\/10 {
  background-color: rgb(121 85 72 / 0.1);
}
.bg-brown-500\\/20 {
  background-color: rgb(121 85 72 / 0.2);
}
.bg-cWhite {
  --tw-bg-opacity: 1;
  background-color: rgb(251 251 253 / var(--tw-bg-opacity));
}
.bg-cardBg {
  --tw-bg-opacity: 1;
  background-color: rgb(251 251 253 / var(--tw-bg-opacity));
}
.bg-current {
  background-color: currentColor;
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.bg-cyan-500\\/10 {
  background-color: rgb(0 188 212 / 0.1);
}
.bg-cyan-500\\/20 {
  background-color: rgb(0 188 212 / 0.2);
}
.bg-deep-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.bg-deep-orange-500\\/10 {
  background-color: rgb(255 87 34 / 0.1);
}
.bg-deep-orange-500\\/20 {
  background-color: rgb(255 87 34 / 0.2);
}
.bg-deep-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.bg-deep-purple-500\\/10 {
  background-color: rgb(103 58 183 / 0.1);
}
.bg-deep-purple-500\\/20 {
  background-color: rgb(103 58 183 / 0.2);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.bg-gray-900\\/10 {
  background-color: rgb(33 33 33 / 0.1);
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.bg-green-500\\/10 {
  background-color: rgb(76 175 80 / 0.1);
}
.bg-green-500\\/20 {
  background-color: rgb(76 175 80 / 0.2);
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.bg-indigo-500\\/10 {
  background-color: rgb(63 81 181 / 0.1);
}
.bg-indigo-500\\/20 {
  background-color: rgb(63 81 181 / 0.2);
}
.bg-inputTypebg {
  --tw-bg-opacity: 1;
  background-color: rgb(247 242 247 / var(--tw-bg-opacity));
}
.bg-light-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.bg-light-blue-500\\/10 {
  background-color: rgb(3 169 244 / 0.1);
}
.bg-light-blue-500\\/20 {
  background-color: rgb(3 169 244 / 0.2);
}
.bg-light-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.bg-light-green-500\\/10 {
  background-color: rgb(139 195 74 / 0.1);
}
.bg-light-green-500\\/20 {
  background-color: rgb(139 195 74 / 0.2);
}
.bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.bg-lime-500\\/10 {
  background-color: rgb(205 220 57 / 0.1);
}
.bg-lime-500\\/20 {
  background-color: rgb(205 220 57 / 0.2);
}
.bg-main {
  --tw-bg-opacity: 1;
  background-color: rgb(69 17 95 / var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.bg-orange-500\\/10 {
  background-color: rgb(255 152 0 / 0.1);
}
.bg-orange-500\\/20 {
  background-color: rgb(255 152 0 / 0.2);
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.bg-pink-500\\/10 {
  background-color: rgb(233 30 99 / 0.1);
}
.bg-pink-500\\/20 {
  background-color: rgb(233 30 99 / 0.2);
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.bg-purple-500\\/10 {
  background-color: rgb(156 39 176 / 0.1);
}
.bg-purple-500\\/20 {
  background-color: rgb(156 39 176 / 0.2);
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.bg-red-500\\/10 {
  background-color: rgb(244 67 54 / 0.1);
}
.bg-red-500\\/20 {
  background-color: rgb(244 67 54 / 0.2);
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(239 196 68 / var(--tw-bg-opacity));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.bg-teal-500\\/10 {
  background-color: rgb(0 150 136 / 0.1);
}
.bg-teal-500\\/20 {
  background-color: rgb(0 150 136 / 0.2);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 238 88 / var(--tw-bg-opacity));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.bg-yellow-500\\/10 {
  background-color: rgb(255 235 59 / 0.1);
}
.bg-yellow-500\\/20 {
  background-color: rgb(255 235 59 / 0.2);
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-amber-600 {
  --tw-gradient-from: #ffb300 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 179 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #1e88e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 136 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-gray-600 {
  --tw-gradient-from: #546e7a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(84 110 122 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brown-600 {
  --tw-gradient-from: #6d4c41 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(109 76 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-600 {
  --tw-gradient-from: #00acc1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 172 193 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-orange-600 {
  --tw-gradient-from: #f4511e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 81 30 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-purple-600 {
  --tw-gradient-from: #5e35b1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(94 53 177 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-600 {
  --tw-gradient-from: #757575 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(117 117 117 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900 {
  --tw-gradient-from: #212121 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(33 33 33 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600 {
  --tw-gradient-from: #43a047 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 160 71 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600 {
  --tw-gradient-from: #3949ab var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(57 73 171 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-blue-600 {
  --tw-gradient-from: #039be5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(3 155 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-green-600 {
  --tw-gradient-from: #7cb342 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 179 66 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-600 {
  --tw-gradient-from: #c0ca33 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 202 51 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-600 {
  --tw-gradient-from: #fb8c00 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 140 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-600 {
  --tw-gradient-from: #d81b60 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(216 27 96 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #8e24aa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(142 36 170 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-600 {
  --tw-gradient-from: #e53935 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(229 57 53 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-600 {
  --tw-gradient-from: #00897b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 137 123 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-600 {
  --tw-gradient-from: #fdd835 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 216 53 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-amber-400 {
  --tw-gradient-to: #ffca28 var(--tw-gradient-to-position);
}
.to-blue-400 {
  --tw-gradient-to: #42a5f5 var(--tw-gradient-to-position);
}
.to-blue-gray-400 {
  --tw-gradient-to: #78909c var(--tw-gradient-to-position);
}
.to-brown-400 {
  --tw-gradient-to: #8d6e63 var(--tw-gradient-to-position);
}
.to-cyan-400 {
  --tw-gradient-to: #26c6da var(--tw-gradient-to-position);
}
.to-deep-orange-400 {
  --tw-gradient-to: #ff7043 var(--tw-gradient-to-position);
}
.to-deep-purple-400 {
  --tw-gradient-to: #7e57c2 var(--tw-gradient-to-position);
}
.to-gray-400 {
  --tw-gradient-to: #bdbdbd var(--tw-gradient-to-position);
}
.to-gray-800 {
  --tw-gradient-to: #424242 var(--tw-gradient-to-position);
}
.to-green-400 {
  --tw-gradient-to: #66bb6a var(--tw-gradient-to-position);
}
.to-indigo-400 {
  --tw-gradient-to: #5c6bc0 var(--tw-gradient-to-position);
}
.to-light-blue-400 {
  --tw-gradient-to: #29b6f6 var(--tw-gradient-to-position);
}
.to-light-green-400 {
  --tw-gradient-to: #9ccc65 var(--tw-gradient-to-position);
}
.to-lime-400 {
  --tw-gradient-to: #d4e157 var(--tw-gradient-to-position);
}
.to-orange-400 {
  --tw-gradient-to: #ffa726 var(--tw-gradient-to-position);
}
.to-pink-400 {
  --tw-gradient-to: #ec407a var(--tw-gradient-to-position);
}
.to-purple-400 {
  --tw-gradient-to: #ab47bc var(--tw-gradient-to-position);
}
.to-red-400 {
  --tw-gradient-to: #ef5350 var(--tw-gradient-to-position);
}
.to-teal-400 {
  --tw-gradient-to: #26a69a var(--tw-gradient-to-position);
}
.to-yellow-400 {
  --tw-gradient-to: #ffee58 var(--tw-gradient-to-position);
}
.bg-clip-border {
  background-clip: border-box;
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[12px\\] {
  padding: 12px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.px-px {
  padding-left: 1px;
  padding-right: 1px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.\\!pr-7 {
  padding-right: 1.75rem !important;
}
.\\!pr-9 {
  padding-right: 2.25rem !important;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-20 {
  padding-left: 5rem;
}
.pr-20 {
  padding-right: 5rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-56 {
  padding-top: 14rem;
}
.pt-\\[9px\\] {
  padding-top: 9px;
}
.pt-px {
  padding-top: 1px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-start {
  text-align: start;
}
.align-middle {
  vertical-align: middle;
}
.font-sans {
  font-family: Roboto, sans-serif;
}
.\\!text-\\[11px\\] {
  font-size: 11px !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.\\!leading-tight {
  line-height: 1.25 !important;
}
.leading-\\[1\\.3\\] {
  line-height: 1.3;
}
.leading-\\[24px\\] {
  line-height: 24px;
}
.leading-\\[3\\.75\\] {
  line-height: 3.75;
}
.leading-\\[4\\.1\\] {
  line-height: 4.1;
}
.leading-\\[4\\.25\\] {
  line-height: 4.25;
}
.leading-\\[4\\.875\\] {
  line-height: 4.875;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\] {
  letter-spacing: 0;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#444444\\] {
  --tw-text-opacity: 1;
  color: rgb(68 68 68 / var(--tw-text-opacity));
}
.text-\\[\\#45115F\\] {
  --tw-text-opacity: 1;
  color: rgb(69 17 95 / var(--tw-text-opacity));
}
.text-\\[\\#45115f\\] {
  --tw-text-opacity: 1;
  color: rgb(69 17 95 / var(--tw-text-opacity));
}
.text-\\[\\#555555\\] {
  --tw-text-opacity: 1;
  color: rgb(85 85 85 / var(--tw-text-opacity));
}
.text-\\[\\#666666\\] {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity));
}
.text-\\[\\#777777\\] {
  --tw-text-opacity: 1;
  color: rgb(119 119 119 / var(--tw-text-opacity));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(255 160 0 / var(--tw-text-opacity));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(255 111 0 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(25 118 210 / var(--tw-text-opacity));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(13 71 161 / var(--tw-text-opacity));
}
.text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}
.text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.text-blue-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(69 90 100 / var(--tw-text-opacity));
}
.text-blue-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.text-brown-500 {
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}
.text-brown-700 {
  --tw-text-opacity: 1;
  color: rgb(93 64 55 / var(--tw-text-opacity));
}
.text-brown-900 {
  --tw-text-opacity: 1;
  color: rgb(62 39 35 / var(--tw-text-opacity));
}
.text-cBlack {
  --tw-text-opacity: 1;
  color: rgb(29 29 31 / var(--tw-text-opacity));
}
.text-cardBg2 {
  --tw-text-opacity: 1;
  color: rgb(69 17 95 / var(--tw-text-opacity));
}
.text-current {
  color: currentColor;
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity));
}
.text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(0 96 100 / var(--tw-text-opacity));
}
.text-deep-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}
.text-deep-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(230 74 25 / var(--tw-text-opacity));
}
.text-deep-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(191 54 12 / var(--tw-text-opacity));
}
.text-deep-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}
.text-deep-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(81 45 168 / var(--tw-text-opacity));
}
.text-deep-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(49 27 146 / var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(224 224 224 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(117 117 117 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(56 142 60 / var(--tw-text-opacity));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(27 94 32 / var(--tw-text-opacity));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(63 81 181 / var(--tw-text-opacity));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(48 63 159 / var(--tw-text-opacity));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(26 35 126 / var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-light-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}
.text-light-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(2 136 209 / var(--tw-text-opacity));
}
.text-light-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(1 87 155 / var(--tw-text-opacity));
}
.text-light-green-500 {
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}
.text-light-green-700 {
  --tw-text-opacity: 1;
  color: rgb(104 159 56 / var(--tw-text-opacity));
}
.text-light-green-900 {
  --tw-text-opacity: 1;
  color: rgb(51 105 30 / var(--tw-text-opacity));
}
.text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}
.text-lime-700 {
  --tw-text-opacity: 1;
  color: rgb(175 180 43 / var(--tw-text-opacity));
}
.text-lime-900 {
  --tw-text-opacity: 1;
  color: rgb(130 119 23 / var(--tw-text-opacity));
}
.text-main {
  --tw-text-opacity: 1;
  color: rgb(69 17 95 / var(--tw-text-opacity));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 152 0 / var(--tw-text-opacity));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(245 124 0 / var(--tw-text-opacity));
}
.text-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(230 81 0 / var(--tw-text-opacity));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(233 30 99 / var(--tw-text-opacity));
}
.text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(194 24 91 / var(--tw-text-opacity));
}
.text-pink-900 {
  --tw-text-opacity: 1;
  color: rgb(136 14 79 / var(--tw-text-opacity));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(156 39 176 / var(--tw-text-opacity));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(123 31 162 / var(--tw-text-opacity));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(74 20 140 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(229 57 53 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(183 28 28 / var(--tw-text-opacity));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(0 150 136 / var(--tw-text-opacity));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(0 121 107 / var(--tw-text-opacity));
}
.text-teal-900 {
  --tw-text-opacity: 1;
  color: rgb(0 77 64 / var(--tw-text-opacity));
}
.text-textMain {
  --tw-text-opacity: 1;
  color: rgb(45 43 43 / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(255 235 59 / var(--tw-text-opacity));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(251 192 45 / var(--tw-text-opacity));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(245 127 23 / var(--tw-text-opacity));
}
.text-opacity-80 {
  --tw-text-opacity: 0.8;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-\\[\\#2D2B2B66\\]::placeholder {
  color: #2D2B2B66;
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_50px_\\#0000001a\\] {
  --tw-shadow: 0px 4px 50px #0000001a;
  --tw-shadow-colored: 0px 4px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-500\\/20 {
  --tw-shadow-color: rgb(255 193 7 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/40 {
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/20 {
  --tw-shadow-color: rgb(33 150 243 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/40 {
  --tw-shadow-color: rgb(33 150 243 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/10 {
  --tw-shadow-color: rgb(96 125 139 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/20 {
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/40 {
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-900\\/10 {
  --tw-shadow-color: rgb(38 50 56 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/20 {
  --tw-shadow-color: rgb(121 85 72 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/40 {
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/20 {
  --tw-shadow-color: rgb(0 188 212 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/40 {
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/20 {
  --tw-shadow-color: rgb(255 87 34 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/40 {
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/20 {
  --tw-shadow-color: rgb(103 58 183 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/40 {
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-900\\/10 {
  --tw-shadow-color: rgb(33 33 33 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-900\\/20 {
  --tw-shadow-color: rgb(33 33 33 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/20 {
  --tw-shadow-color: rgb(76 175 80 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/40 {
  --tw-shadow-color: rgb(76 175 80 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/20 {
  --tw-shadow-color: rgb(63 81 181 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/40 {
  --tw-shadow-color: rgb(63 81 181 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/20 {
  --tw-shadow-color: rgb(3 169 244 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/40 {
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/20 {
  --tw-shadow-color: rgb(139 195 74 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/40 {
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/20 {
  --tw-shadow-color: rgb(205 220 57 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/40 {
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/20 {
  --tw-shadow-color: rgb(255 152 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/40 {
  --tw-shadow-color: rgb(255 152 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/20 {
  --tw-shadow-color: rgb(233 30 99 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/40 {
  --tw-shadow-color: rgb(233 30 99 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/20 {
  --tw-shadow-color: rgb(156 39 176 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/40 {
  --tw-shadow-color: rgb(156 39 176 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/20 {
  --tw-shadow-color: rgb(244 67 54 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/40 {
  --tw-shadow-color: rgb(244 67 54 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/20 {
  --tw-shadow-color: rgb(0 150 136 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/40 {
  --tw-shadow-color: rgb(0 150 136 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/20 {
  --tw-shadow-color: rgb(255 235 59 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/40 {
  --tw-shadow-color: rgb(255 235 59 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-0 {
  outline-width: 0px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-200 {
  --tw-backdrop-saturate: saturate(2);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.content-\\[\\'\\'\\] {
  --tw-content: '';
  content: var(--tw-content);
}
.\\[-webkit-appearance\\:none\\] {
  -webkit-appearance: none;
}
.\\[font-family\\:\\'Manrope-SemiBold\\'\\2c Helvetica\\] {
  font-family: 'Manrope-SemiBold',Helvetica;
}

.font-200 {
  font-weight: 200;
}

.font-300 {
  font-weight: 300;
}

.font-400 {
  font-weight: 400;
}

.font-500 {
  font-weight: 500;
}

.font-600 {
  font-weight: 600;
}

.font-700 {
  font-weight: 700;
}

.font-800 {
  font-weight: 800;
}

.Splash {
  background: linear-gradient(to bottom, #888888, #000000, #ffffff);
}

* {
  letter-spacing: 1.5% !important;
  font-family: "Manrope", sans-serif !important;
}

/* index.css */
body {
  /* Set the default scrollbar width and color */
  font-family: "Manrope", sans-serif;
  color: #1d1d1f;
  background-color: #fbfbfd;
  scrollbar-width: thin;

  /* Set the width and color of the thumb (the draggable part of the scrollbar) */
  /* The first color (purple) represents the thumb color, the second (transparent) represents the track color */
  scrollbar-color: purple transparent;
}

/* Define the scrollbar styles for WebKit-based browsers */
/* You can adjust the height and color to your preference */
/* The first color (purple) represents the thumb color, the second (transparent) represents the track color */
body::-webkit-scrollbar {
  width: 6px; /* Set the width of the scrollbar */
}

body::-webkit-scrollbar-thumb {
  background-color: purple; /* Set the color of the scrollbar thumb */
  border-radius: 3px; /* Round the corners of the thumb */
}

body::-webkit-scrollbar-thumb:hover {
  background-color: #a000a0; /* Change the color on hover (optional) */
}

body::-webkit-scrollbar-track {
  background-color: transparent; /* Set the color of the scrollbar track */
}

.chatbot-scrollbar::-webkit-scrollbar {
  width: 6px; /* Set the width of the scrollbar */
}

.chatbot-scrollbar::-webkit-scrollbar-thumb {
  background-color: purple; /* Set the color of the scrollbar thumb */
  border-radius: 3px; /* Round the corners of the thumb */
}

.chatbot-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #a000a0; /* Change the color on hover (optional) */
}

.form-submit-hover-animations {
  /* hover:border-b-main hover:border-b-2 hover:rounded-md hover:bg-main  hover:text-white */
  box-shadow: inset -10.5em 0 0 0 #45115f, inset 10.5em 0 0 0 #45115f;
  color: #ffffff;
}

/* .form-submit-hover-animations:hover::after {
  width: 100%;
} */

.chatbot-bg {
  border-radius: 40px;
  background: linear-gradient(0deg, #eee7f0 0%, #eee7f0 100%), #fff;
}

.question-bg {
  border-radius: var(--none, 0px);
  background: var(--p-purple-80, rgba(69, 17, 95, 0.8));
}

/* Button */

.button-img-ios,
.button-img-android {
  transition: transform 0.3s ease;
}

.button-img-ios {
  width: 150px;
}

.button-img-android {
  width: 170px;
}

.button-img-ios:hover,
.button-img-android:hover {
  transform: scale(0.95);
}

.hero-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom right;
  margin-top: -40px;
}

.about-img{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom right;
}

.getstarted-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom right;
}

.faq-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom right;
}

.contact-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom right;
}

.getstartedIMG {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  /* background-repeat: no-repeat; */
}

@media (max-width: 1366px) {
  @media (min-width: 768px) {
    /* Your styles for screens 1366px and below (up to md breakpoint) */
    /* For example: */
    .hero-title {
      font-size: 3.5rem !important;
    }

    .hero-subtitle {
      font-size: 24px !important;
      line-height: 28px !important;
    }
    .hero-bg-line {
      height: 50%;
    }
  }
}

.zoom-in {
  transform: scale(1.5);
  transition: transform 0.5s;
}

.footerSectionBg {
  background: radial-gradient(
      647.9% 103.11% at 94.92% 58.65%,
      rgba(238, 203, 255, 0.12) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    radial-gradient(
      230.13% 117.13% at 27.79% 13.14%,
      rgba(238, 203, 255, 0.12) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    #45115f;
}


  .scroll-section {
    position: relative;
    overflow: hidden;
  }

  /* Remove any default margin and padding */
  .scroll-section, .scroll-section * {
    margin: 0;
    /* padding: 0; */
  }

  /* Optional: Remove outline on focus for accessibility */
  .scroll-section a:focus, .scroll-section button:focus {
    outline: none;
  }

  /* Optional: Remove any default browser styles for the scrollbar */
  .scroll-section::-webkit-scrollbar {
    display: none; /* Optional: Hide scrollbar */
  }


  .bgContainer{
    background-color: #fff;
    height: auto;
    width: 100%;
    background-image: linear-gradient(60deg , #fff, #F9EEFF, #F3DCFF);
    background-size: 400% 400%;
    animation: animate 2s ease infinite;
  }


@keyframes animate {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@media screen and (max-width: 768px) {
  .bgContainer{
    background-color: #fff;
    height: auto;
    width: 100%;
    background-image: linear-gradient(60deg , #fff, #F9EEFF, #F3DCFF);
    background-size: 400% 400%;
    animation: animate 2s ease infinite;
  }
}

.placeholder\\:text-center::placeholder {
  text-align: center;
}

.before\\:pointer-events-none::before {
  content: var(--tw-content);
  pointer-events: none;
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:left-2\\/4::before {
  content: var(--tw-content);
  left: 50%;
}

.before\\:top-2\\/4::before {
  content: var(--tw-content);
  top: 50%;
}

.before\\:mr-1::before {
  content: var(--tw-content);
  margin-right: 0.25rem;
}

.before\\:mt-\\[6\\.5px\\]::before {
  content: var(--tw-content);
  margin-top: 6.5px;
}

.before\\:box-border::before {
  content: var(--tw-content);
  box-sizing: border-box;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:h-1::before {
  content: var(--tw-content);
  height: 0.25rem;
}

.before\\:h-1\\.5::before {
  content: var(--tw-content);
  height: 0.375rem;
}

.before\\:h-10::before {
  content: var(--tw-content);
  height: 2.5rem;
}

.before\\:h-12::before {
  content: var(--tw-content);
  height: 3rem;
}

.before\\:w-10::before {
  content: var(--tw-content);
  width: 2.5rem;
}

.before\\:w-12::before {
  content: var(--tw-content);
  width: 3rem;
}

.before\\:w-2::before {
  content: var(--tw-content);
  width: 0.5rem;
}

.before\\:w-2\\.5::before {
  content: var(--tw-content);
  width: 0.625rem;
}

.before\\:-translate-x-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:-translate-y-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:rounded-tl-md::before {
  content: var(--tw-content);
  border-top-left-radius: 0.375rem;
}

.before\\:border-l::before {
  content: var(--tw-content);
  border-left-width: 1px;
}

.before\\:border-l-2::before {
  content: var(--tw-content);
  border-left-width: 2px;
}

.before\\:border-t::before {
  content: var(--tw-content);
  border-top-width: 1px;
}

.before\\:border-t-2::before {
  content: var(--tw-content);
  border-top-width: 2px;
}

.before\\:\\!border-blue-gray-200::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}

.before\\:border-amber-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.before\\:border-black::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.before\\:border-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.before\\:border-blue-gray-200::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.before\\:border-blue-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.before\\:border-brown-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.before\\:border-cyan-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.before\\:border-deep-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.before\\:border-deep-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.before\\:border-gray-900::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.before\\:border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.before\\:border-indigo-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.before\\:border-light-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.before\\:border-light-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.before\\:border-lime-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.before\\:border-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.before\\:border-pink-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.before\\:border-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.before\\:border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.before\\:border-teal-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}

.before\\:border-white::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.before\\:border-yellow-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.before\\:border-l-transparent::before {
  content: var(--tw-content);
  border-left-color: transparent;
}

.before\\:border-t-transparent::before {
  content: var(--tw-content);
  border-top-color: transparent;
}

.before\\:bg-blue-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.before\\:opacity-0::before {
  content: var(--tw-content);
  opacity: 0;
}

.before\\:transition-all::before {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:transition-opacity::before {
  content: var(--tw-content);
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:pointer-events-none::after {
  content: var(--tw-content);
  pointer-events: none;
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:-bottom-0::after {
  content: var(--tw-content);
  bottom: -0px;
}

.after\\:-bottom-1::after {
  content: var(--tw-content);
  bottom: -0.25rem;
}

.after\\:-bottom-1\\.5::after {
  content: var(--tw-content);
  bottom: -0.375rem;
}

.after\\:-bottom-2::after {
  content: var(--tw-content);
  bottom: -0.5rem;
}

.after\\:-bottom-2\\.5::after {
  content: var(--tw-content);
  bottom: -0.625rem;
}

.after\\:ml-1::after {
  content: var(--tw-content);
  margin-left: 0.25rem;
}

.after\\:mt-\\[6\\.5px\\]::after {
  content: var(--tw-content);
  margin-top: 6.5px;
}

.after\\:box-border::after {
  content: var(--tw-content);
  box-sizing: border-box;
}

.after\\:block::after {
  content: var(--tw-content);
  display: block;
}

.after\\:h-1::after {
  content: var(--tw-content);
  height: 0.25rem;
}

.after\\:h-1\\.5::after {
  content: var(--tw-content);
  height: 0.375rem;
}

.after\\:h-\\[3px\\]::after {
  content: var(--tw-content);
  height: 3px;
}

.after\\:w-2::after {
  content: var(--tw-content);
  width: 0.5rem;
}

.after\\:w-2\\.5::after {
  content: var(--tw-content);
  width: 0.625rem;
}

.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}

.after\\:flex-grow::after {
  content: var(--tw-content);
  flex-grow: 1;
}

.after\\:origin-left::after {
  content: var(--tw-content);
  transform-origin: left;
}

.after\\:scale-x-0::after {
  content: var(--tw-content);
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:scale-x-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rounded-tr-md::after {
  content: var(--tw-content);
  border-top-right-radius: 0.375rem;
}

.after\\:border-b-2::after {
  content: var(--tw-content);
  border-bottom-width: 2px;
}

.after\\:border-r::after {
  content: var(--tw-content);
  border-right-width: 1px;
}

.after\\:border-r-2::after {
  content: var(--tw-content);
  border-right-width: 2px;
}

.after\\:border-t::after {
  content: var(--tw-content);
  border-top-width: 1px;
}

.after\\:border-t-2::after {
  content: var(--tw-content);
  border-top-width: 2px;
}

.after\\:\\!border-blue-gray-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}

.after\\:border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.after\\:border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.after\\:border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.after\\:border-blue-gray-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.after\\:border-blue-gray-50::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}

.after\\:border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.after\\:border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.after\\:border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.after\\:border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.after\\:border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.after\\:border-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}

.after\\:border-gray-900::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.after\\:border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.after\\:border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.after\\:border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.after\\:border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.after\\:border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.after\\:border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.after\\:border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.after\\:border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.after\\:border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.after\\:border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}

.after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.after\\:border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.after\\:border-r-transparent::after {
  content: var(--tw-content);
  border-right-color: transparent;
}

.after\\:border-t-transparent::after {
  content: var(--tw-content);
  border-top-color: transparent;
}

.after\\:bg-main::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(69 17 95 / var(--tw-bg-opacity));
}

.after\\:transition::after {
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:transition-transform::after {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:duration-300::after {
  content: var(--tw-content);
  transition-duration: 300ms;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.checked\\:border-amber-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.checked\\:border-blue-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.checked\\:border-blue-gray-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.checked\\:border-brown-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.checked\\:border-cyan-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.checked\\:border-deep-orange-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.checked\\:border-deep-purple-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.checked\\:border-gray-900:checked {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.checked\\:border-green-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.checked\\:border-indigo-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.checked\\:border-light-blue-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.checked\\:border-light-green-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.checked\\:border-lime-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.checked\\:border-orange-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.checked\\:border-pink-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.checked\\:border-purple-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.checked\\:border-red-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.checked\\:border-teal-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.checked\\:border-yellow-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.checked\\:bg-amber-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}

.checked\\:bg-blue-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}

.checked\\:bg-blue-gray-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.checked\\:bg-brown-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}

.checked\\:bg-cyan-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}

.checked\\:bg-deep-orange-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}

.checked\\:bg-deep-purple-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}

.checked\\:bg-gray-900:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}

.checked\\:bg-green-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}

.checked\\:bg-indigo-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}

.checked\\:bg-light-blue-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}

.checked\\:bg-light-green-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}

.checked\\:bg-lime-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}

.checked\\:bg-orange-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}

.checked\\:bg-pink-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}

.checked\\:bg-purple-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}

.checked\\:bg-red-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}

.checked\\:bg-teal-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}

.checked\\:bg-yellow-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-amber-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-blue-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-blue-gray-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-brown-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-cyan-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-deep-orange-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-deep-purple-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-gray-900:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-green-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-indigo-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-light-blue-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-light-green-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-lime-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-orange-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-pink-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-purple-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-red-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-teal-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-yellow-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}

.placeholder-shown\\:border:placeholder-shown {
  border-width: 1px;
}

.placeholder-shown\\:border-blue-gray-200:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-green-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-red-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-t-blue-gray-200:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-t-green-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-t-red-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-75:hover {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-90:hover {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-95:hover {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:rounded-md:hover {
  border-radius: 0.375rem;
}

.hover\\:border-b-2:hover {
  border-bottom-width: 2px;
}

.hover\\:border-b-main:hover {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(69 17 95 / var(--tw-border-opacity));
}

.hover\\:bg-\\[\\#331940\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(51 25 64 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#45115f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(69 17 95 / var(--tw-bg-opacity));
}

.hover\\:bg-amber-500\\/10:hover {
  background-color: rgb(255 193 7 / 0.1);
}

.hover\\:bg-blue-500\\/10:hover {
  background-color: rgb(33 150 243 / 0.1);
}

.hover\\:bg-blue-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-gray-500\\/10:hover {
  background-color: rgb(96 125 139 / 0.1);
}

.hover\\:bg-brown-500\\/10:hover {
  background-color: rgb(121 85 72 / 0.1);
}

.hover\\:bg-cyan-500\\/10:hover {
  background-color: rgb(0 188 212 / 0.1);
}

.hover\\:bg-deep-orange-500\\/10:hover {
  background-color: rgb(255 87 34 / 0.1);
}

.hover\\:bg-deep-purple-500\\/10:hover {
  background-color: rgb(103 58 183 / 0.1);
}

.hover\\:bg-gray-900\\/10:hover {
  background-color: rgb(33 33 33 / 0.1);
}

.hover\\:bg-green-500\\/10:hover {
  background-color: rgb(76 175 80 / 0.1);
}

.hover\\:bg-indigo-500\\/10:hover {
  background-color: rgb(63 81 181 / 0.1);
}

.hover\\:bg-light-blue-500\\/10:hover {
  background-color: rgb(3 169 244 / 0.1);
}

.hover\\:bg-light-green-500\\/10:hover {
  background-color: rgb(139 195 74 / 0.1);
}

.hover\\:bg-lime-500\\/10:hover {
  background-color: rgb(205 220 57 / 0.1);
}

.hover\\:bg-main:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(69 17 95 / var(--tw-bg-opacity));
}

.hover\\:bg-orange-500\\/10:hover {
  background-color: rgb(255 152 0 / 0.1);
}

.hover\\:bg-pink-500\\/10:hover {
  background-color: rgb(233 30 99 / 0.1);
}

.hover\\:bg-purple-500\\/10:hover {
  background-color: rgb(156 39 176 / 0.1);
}

.hover\\:bg-red-500\\/10:hover {
  background-color: rgb(244 67 54 / 0.1);
}

.hover\\:bg-secondary2:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 198 28 / var(--tw-bg-opacity));
}

.hover\\:bg-teal-500\\/10:hover {
  background-color: rgb(0 150 136 / 0.1);
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-yellow-500\\/10:hover {
  background-color: rgb(255 235 59 / 0.1);
}

.hover\\:bg-opacity-80:hover {
  --tw-bg-opacity: 0.8;
}

.hover\\:text-blue-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.hover\\:text-blue-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}

.hover\\:text-light-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}

.hover\\:text-main:hover {
  --tw-text-opacity: 1;
  color: rgb(69 17 95 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:opacity-75:hover {
  opacity: 0.75;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-amber-500\\/40:hover {
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-500\\/40:hover {
  --tw-shadow-color: rgb(33 150 243 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-gray-500\\/20:hover {
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-gray-500\\/40:hover {
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-brown-500\\/40:hover {
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-cyan-500\\/40:hover {
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-deep-orange-500\\/40:hover {
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-deep-purple-500\\/40:hover {
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-gray-900\\/20:hover {
  --tw-shadow-color: rgb(33 33 33 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-green-500\\/40:hover {
  --tw-shadow-color: rgb(76 175 80 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-indigo-500\\/40:hover {
  --tw-shadow-color: rgb(63 81 181 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-light-blue-500\\/40:hover {
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-light-green-500\\/40:hover {
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-lime-500\\/40:hover {
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-orange-500\\/40:hover {
  --tw-shadow-color: rgb(255 152 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-pink-500\\/40:hover {
  --tw-shadow-color: rgb(233 30 99 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-purple-500\\/40:hover {
  --tw-shadow-color: rgb(156 39 176 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-red-500\\/40:hover {
  --tw-shadow-color: rgb(244 67 54 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-teal-500\\/40:hover {
  --tw-shadow-color: rgb(0 150 136 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-yellow-500\\/40:hover {
  --tw-shadow-color: rgb(255 235 59 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:before\\:opacity-10:hover::before {
  content: var(--tw-content);
  opacity: 0.1;
}

.after\\:hover\\:scale-x-100:hover::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.focus\\:scale-110:focus {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.focus\\:border-2:focus {
  border-width: 2px;
}

.focus\\:border-amber-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.focus\\:border-blue-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.focus\\:border-blue-gray-900:focus {
  --tw-border-opacity: 1;
  border-color: rgb(38 50 56 / var(--tw-border-opacity));
}

.focus\\:border-brown-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.focus\\:border-cyan-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.focus\\:border-deep-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.focus\\:border-deep-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.focus\\:border-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}

.focus\\:border-gray-900:focus {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.focus\\:border-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.focus\\:border-light-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.focus\\:border-light-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.focus\\:border-lime-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.focus\\:border-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.focus\\:border-pink-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.focus\\:border-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.focus\\:border-teal-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.focus\\:border-white:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.focus\\:border-yellow-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.focus\\:border-t-transparent:focus {
  border-top-color: transparent;
}

.focus\\:bg-blue-gray-50:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.focus\\:bg-transparent:focus {
  background-color: transparent;
}

.focus\\:bg-opacity-80:focus {
  --tw-bg-opacity: 0.8;
}

.focus\\:text-blue-gray-500:focus {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.focus\\:text-blue-gray-900:focus {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}

.focus\\:opacity-\\[0\\.85\\]:focus {
  opacity: 0.85;
}

.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-0:focus {
  outline-width: 0px;
}

.focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-amber-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 224 130 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(144 202 249 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(176 190 197 / var(--tw-ring-opacity));
}

.focus\\:ring-brown-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(188 170 164 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(128 222 234 / var(--tw-ring-opacity));
}

.focus\\:ring-deep-orange-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 171 145 / var(--tw-ring-opacity));
}

.focus\\:ring-deep-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(179 157 219 / var(--tw-ring-opacity));
}

.focus\\:ring-gray-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 224 224 / var(--tw-ring-opacity));
}

.focus\\:ring-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 214 167 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(159 168 218 / var(--tw-ring-opacity));
}

.focus\\:ring-light-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 212 250 / var(--tw-ring-opacity));
}

.focus\\:ring-light-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(197 225 165 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(230 238 156 / var(--tw-ring-opacity));
}

.focus\\:ring-orange-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 204 128 / var(--tw-ring-opacity));
}

.focus\\:ring-pink-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 143 177 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(206 147 216 / var(--tw-ring-opacity));
}

.focus\\:ring-red-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 154 154 / var(--tw-ring-opacity));
}

.focus\\:ring-teal-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(128 203 196 / var(--tw-ring-opacity));
}

.focus\\:ring-white\\/50:focus {
  --tw-ring-color: rgb(255 255 255 / 0.5);
}

.focus\\:ring-yellow-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 245 157 / var(--tw-ring-opacity));
}

.active\\:scale-100:active {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:bg-amber-500\\/30:active {
  background-color: rgb(255 193 7 / 0.3);
}

.active\\:bg-blue-500\\/30:active {
  background-color: rgb(33 150 243 / 0.3);
}

.active\\:bg-blue-gray-50:active {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.active\\:bg-blue-gray-500\\/30:active {
  background-color: rgb(96 125 139 / 0.3);
}

.active\\:bg-brown-500\\/30:active {
  background-color: rgb(121 85 72 / 0.3);
}

.active\\:bg-cyan-500\\/30:active {
  background-color: rgb(0 188 212 / 0.3);
}

.active\\:bg-deep-orange-500\\/30:active {
  background-color: rgb(255 87 34 / 0.3);
}

.active\\:bg-deep-purple-500\\/30:active {
  background-color: rgb(103 58 183 / 0.3);
}

.active\\:bg-gray-900\\/20:active {
  background-color: rgb(33 33 33 / 0.2);
}

.active\\:bg-green-500\\/30:active {
  background-color: rgb(76 175 80 / 0.3);
}

.active\\:bg-indigo-500\\/30:active {
  background-color: rgb(63 81 181 / 0.3);
}

.active\\:bg-light-blue-500\\/30:active {
  background-color: rgb(3 169 244 / 0.3);
}

.active\\:bg-light-green-500\\/30:active {
  background-color: rgb(139 195 74 / 0.3);
}

.active\\:bg-lime-500\\/30:active {
  background-color: rgb(205 220 57 / 0.3);
}

.active\\:bg-orange-500\\/30:active {
  background-color: rgb(255 152 0 / 0.3);
}

.active\\:bg-pink-500\\/30:active {
  background-color: rgb(233 30 99 / 0.3);
}

.active\\:bg-purple-500\\/30:active {
  background-color: rgb(156 39 176 / 0.3);
}

.active\\:bg-red-500\\/30:active {
  background-color: rgb(244 67 54 / 0.3);
}

.active\\:bg-teal-500\\/30:active {
  background-color: rgb(0 150 136 / 0.3);
}

.active\\:bg-transparent:active {
  background-color: transparent;
}

.active\\:bg-white\\/30:active {
  background-color: rgb(255 255 255 / 0.3);
}

.active\\:bg-yellow-500\\/30:active {
  background-color: rgb(255 235 59 / 0.3);
}

.active\\:bg-opacity-80:active {
  --tw-bg-opacity: 0.8;
}

.active\\:text-blue-gray-500:active {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.active\\:text-blue-gray-900:active {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}

.active\\:opacity-\\[0\\.85\\]:active {
  opacity: 0.85;
}

.active\\:shadow-none:active {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:resize-none:disabled {
  resize: none;
}

.disabled\\:border-0:disabled {
  border-width: 0px;
}

.disabled\\:bg-blue-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:text-\\[\\#eee7f0\\] {
  --tw-text-opacity: 1;
  color: rgb(238 231 240 / var(--tw-text-opacity));
}

.peer:checked ~ .peer-checked\\:translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-blue-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-brown-500 {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-deep-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-deep-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-light-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-light-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:opacity-100 {
  opacity: 1;
}

.peer:checked ~ .peer-checked\\:before\\:bg-amber-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-blue-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-blue-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-brown-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-cyan-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-deep-orange-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-deep-purple-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-gray-900::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-green-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-indigo-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-light-blue-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-light-green-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-lime-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-orange-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-pink-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-purple-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-red-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-teal-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-yellow-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[3\\.75\\] {
  line-height: 3.75;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.1\\] {
  line-height: 4.1;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.25\\] {
  line-height: 4.25;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.875\\] {
  line-height: 4.875;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-tight {
  line-height: 1.25;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:focus ~ .peer-focus\\:text-\\[11px\\] {
  font-size: 11px;
}

.peer:focus ~ .peer-focus\\:text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.peer:focus ~ .peer-focus\\:leading-tight {
  line-height: 1.25;
}

.peer:focus ~ .peer-focus\\:text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-brown-500 {
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-deep-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-deep-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(63 81 181 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-light-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-light-green-500 {
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 152 0 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(233 30 99 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(156 39 176 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(0 150 136 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(255 235 59 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:before\\:border-l-2::before {
  content: var(--tw-content);
  border-left-width: 2px;
}

.peer:focus ~ .peer-focus\\:before\\:border-t-2::before {
  content: var(--tw-content);
  border-top-width: 2px;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-amber-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-black::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 150 243 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-brown-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-cyan-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-gray-900::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 33 33 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(76 175 80 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-indigo-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 81 181 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-light-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-light-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-lime-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 152 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-pink-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 30 99 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 39 176 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 67 54 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-teal-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 150 136 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-white::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-yellow-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 235 59 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:before\\:border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:scale-x-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:after\\:border-r-2::after {
  content: var(--tw-content);
  border-right-width: 2px;
}

.peer:focus ~ .peer-focus\\:after\\:border-t-2::after {
  content: var(--tw-content);
  border-top-width: 2px;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 150 243 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-gray-900::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 33 33 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(76 175 80 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 81 181 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 152 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 30 99 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 39 176 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 67 54 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 150 136 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 235 59 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-gray-900::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}

.peer:disabled ~ .peer-disabled\\:text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}

.peer:disabled ~ .peer-disabled\\:text-transparent {
  color: transparent;
}

.peer:disabled ~ .peer-disabled\\:before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:disabled ~ .peer-disabled\\:after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:disabled:placeholder-shown ~ .peer-disabled\\:peer-placeholder-shown\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

@media (min-width: 640px) {

  .sm\\:right-5 {
    right: 1.25rem;
  }

  .sm\\:right-8 {
    right: 2rem;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:-mt-0 {
    margin-top: -0px;
  }

  .sm\\:mt-60 {
    margin-top: 15rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-\\[30vh\\] {
    height: 30vh;
  }

  .sm\\:h-\\[420px\\] {
    height: 420px;
  }

  .sm\\:w-\\[200px\\] {
    width: 200px;
  }

  .sm\\:w-\\[360px\\] {
    width: 360px;
  }

  .sm\\:scale-100 {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:gap-0 {
    gap: 0px;
  }

  .sm\\:gap-10 {
    gap: 2.5rem;
  }

  .sm\\:p-10 {
    padding: 2.5rem;
  }

  .sm\\:p-20 {
    padding: 5rem;
  }

  .sm\\:p-24 {
    padding: 6rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .sm\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:pl-24 {
    padding-left: 6rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 768px) {

  .md\\:top-24 {
    top: 6rem;
  }

  .md\\:-mt-20 {
    margin-top: -5rem;
  }

  .md\\:-mt-24 {
    margin-top: -6rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:h-1\\/2 {
    height: 50%;
  }

  .md\\:h-\\[60\\%\\] {
    height: 60%;
  }

  .md\\:h-\\[800px\\] {
    height: 800px;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-3\\/4 {
    width: 75%;
  }

  .md\\:w-3\\/5 {
    width: 60%;
  }

  .md\\:w-5\\/6 {
    width: 83.333333%;
  }

  .md\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .md\\:min-w-\\[66\\.666667\\%\\] {
    min-width: 66.666667%;
  }

  .md\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .md\\:min-w-\\[83\\.333333\\%\\] {
    min-width: 83.333333%;
  }

  .md\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .md\\:max-w-\\[66\\.666667\\%\\] {
    max-width: 66.666667%;
  }

  .md\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .md\\:max-w-\\[83\\.333333\\%\\] {
    max-width: 83.333333%;
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-20 {
    padding: 5rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .md\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .md\\:pt-10 {
    padding-top: 2.5rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .md\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:top-16 {
    top: 4rem;
  }

  .lg\\:-my-\\[420px\\] {
    margin-top: -420px;
    margin-bottom: -420px;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:-ml-0 {
    margin-left: -0px;
  }

  .lg\\:-mt-0 {
    margin-top: -0px;
  }

  .lg\\:-mt-16 {
    margin-top: -4rem;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-60 {
    margin-top: 15rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[30vh\\] {
    height: 30vh;
  }

  .lg\\:h-\\[70vh\\] {
    height: 70vh;
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:h-screen {
    height: 100vh;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-2\\/3 {
    width: 66.666667%;
  }

  .lg\\:w-2\\/4 {
    width: 50%;
  }

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:w-3\\/5 {
    width: 60%;
  }

  .lg\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .lg\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .lg\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:min-w-\\[40\\%\\] {
    min-width: 40%;
  }

  .lg\\:min-w-\\[50\\%\\] {
    min-width: 50%;
  }

  .lg\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .lg\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .lg\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .lg\\:max-w-\\[460px\\] {
    max-width: 460px;
  }

  .lg\\:max-w-\\[490px\\] {
    max-width: 490px;
  }

  .lg\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }

  .lg\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .lg\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:gap-0 {
    gap: 0px;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-80 {
    gap: 20rem;
  }

  .lg\\:gap-x-40 {
    column-gap: 10rem;
  }

  .lg\\:p-0 {
    padding: 0px;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-20 {
    padding: 5rem;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .lg\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .lg\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:pb-0 {
    padding-bottom: 0px;
  }

  .lg\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .lg\\:pb-20 {
    padding-bottom: 5rem;
  }

  .lg\\:pl-10 {
    padding-left: 2.5rem;
  }

  .lg\\:pl-24 {
    padding-left: 6rem;
  }

  .lg\\:pl-48 {
    padding-left: 12rem;
  }

  .lg\\:pr-10 {
    padding-right: 2.5rem;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:pt-10 {
    padding-top: 2.5rem;
  }

  .lg\\:pt-20 {
    padding-top: 5rem;
  }

  .lg\\:pt-32 {
    padding-top: 8rem;
  }

  .lg\\:pt-40 {
    padding-top: 10rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-start {
    text-align: start;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:h-full {
    height: 100%;
  }

  .xl\\:h-screen {
    height: 100vh;
  }

  .xl\\:w-1\\/2 {
    width: 50%;
  }

  .xl\\:w-2\\/3 {
    width: 66.666667%;
  }

  .xl\\:w-4\\/5 {
    width: 80%;
  }

  .xl\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .xl\\:w-full {
    width: 100%;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:justify-start {
    justify-content: flex-start;
  }

  .xl\\:gap-14 {
    gap: 3.5rem;
  }

  .xl\\:gap-40 {
    gap: 10rem;
  }

  .xl\\:gap-\\[230px\\] {
    gap: 230px;
  }

  .xl\\:p-0 {
    padding: 0px;
  }

  .xl\\:px-28 {
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .xl\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .xl\\:px-52 {
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .xl\\:px-80 {
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .xl\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .xl\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .xl\\:pl-32 {
    padding-left: 8rem;
  }

  .xl\\:pl-48 {
    padding-left: 12rem;
  }

  .xl\\:pr-10 {
    padding-right: 2.5rem;
  }

  .xl\\:text-left {
    text-align: left;
  }

  .xl\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .xl\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .xl\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .xl\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:h-full {
    height: 100%;
  }

  .\\32xl\\:w-1\\/3 {
    width: 33.333333%;
  }

  .\\32xl\\:w-1\\/4 {
    width: 25%;
  }

  .\\32xl\\:w-2\\/5 {
    width: 40%;
  }

  .\\32xl\\:w-3\\/4 {
    width: 75%;
  }

  .\\32xl\\:w-3\\/5 {
    width: 60%;
  }

  .\\32xl\\:min-w-\\[25\\%\\] {
    min-width: 25%;
  }

  .\\32xl\\:min-w-\\[33\\.333333\\%\\] {
    min-width: 33.333333%;
  }

  .\\32xl\\:min-w-\\[40\\%\\] {
    min-width: 40%;
  }

  .\\32xl\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .\\32xl\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .\\32xl\\:max-w-\\[25\\%\\] {
    max-width: 25%;
  }

  .\\32xl\\:max-w-\\[33\\.333333\\%\\] {
    max-width: 33.333333%;
  }

  .\\32xl\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .\\32xl\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .\\32xl\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .\\32xl\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:relative::-moz-range-thumb {
  position: relative;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:z-20::-moz-range-thumb {
  z-index: 20;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-1::-moz-range-thumb {
  margin-top: -0.25rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-\\[3px\\]::-moz-range-thumb {
  margin-top: -3px;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-2\\.5::-moz-range-thumb {
  height: 0.625rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-3\\.5::-moz-range-thumb {
  height: 0.875rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-5::-moz-range-thumb {
  height: 1.25rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-2\\.5::-moz-range-thumb {
  width: 0.625rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-3\\.5::-moz-range-thumb {
  width: 0.875rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-5::-moz-range-thumb {
  width: 1.25rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:appearance-none::-moz-range-thumb {
  appearance: none;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:rounded-full::-moz-range-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:border-0::-moz-range-thumb {
  border-width: 0px;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:bg-white::-moz-range-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-2::-moz-range-thumb {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-current::-moz-range-thumb {
  --tw-ring-color: currentColor;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-moz-range-thumb {
  -webkit-appearance: none;
}

.\\[\\&\\:\\:-moz-range-track\\]\\:h-full::-moz-range-track {
  height: 100%;
}

.\\[\\&\\:\\:-moz-range-track\\]\\:rounded-full::-moz-range-track {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-moz-range-track\\]\\:bg-blue-gray-100::-moz-range-track {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:h-full::-webkit-slider-runnable-track {
  height: 100%;
}

.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:rounded-full::-webkit-slider-runnable-track {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:bg-blue-gray-100::-webkit-slider-runnable-track {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:relative::-webkit-slider-thumb {
  position: relative;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:z-20::-webkit-slider-thumb {
  z-index: 20;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-1::-webkit-slider-thumb {
  margin-top: -0.25rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-\\[3px\\]::-webkit-slider-thumb {
  margin-top: -3px;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-2\\.5::-webkit-slider-thumb {
  height: 0.625rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-3\\.5::-webkit-slider-thumb {
  height: 0.875rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-5::-webkit-slider-thumb {
  height: 1.25rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-2\\.5::-webkit-slider-thumb {
  width: 0.625rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-3\\.5::-webkit-slider-thumb {
  width: 0.875rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-5::-webkit-slider-thumb {
  width: 1.25rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:appearance-none::-webkit-slider-thumb {
  appearance: none;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:rounded-full::-webkit-slider-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:border-0::-webkit-slider-thumb {
  border-width: 0px;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-white::-webkit-slider-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-2::-webkit-slider-thumb {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-current::-webkit-slider-thumb {
  --tw-ring-color: currentColor;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-webkit-slider-thumb {
  -webkit-appearance: none;
}

`, "",{"version":3,"sources":["webpack://./src/index.css","<no source>"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAKnB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA,cAAc;AACd;EACE,8CAA8C;EAC9C,kCAAkC;EAClC,cAAc;EACd,yBAAyB;EACzB,qBAAqB;;EAGrB,+EAA+E;EAC/E,6GAA6G;EAC7G,mCAAmC;AACrC;;AAEA,0DAA0D;AAC1D,2DAA2D;AAC3D,6GAA6G;AAC7G;EACE,UAAU,EAAE,mCAAmC;AACjD;;AAEA;EACE,wBAAwB,EAAE,yCAAyC;EACnE,kBAAkB,EAAE,mCAAmC;AACzD;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA;EACE,6BAA6B,EAAE,yCAAyC;AAC1E;;AAEA;EACE,UAAU,EAAE,mCAAmC;AACjD;;AAEA;EACE,wBAAwB,EAAE,yCAAyC;EACnE,kBAAkB,EAAE,mCAAmC;AACzD;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA;EACE,0FAA0F;EAC1F,mEAAmE;EACnE,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,iEAAiE;AACnE;;AAEA;EACE,+BAA+B;EAC/B,qDAAqD;AACvD;;AAEA,WAAW;;AAEX;;EAEE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yDAAyD;EACzD,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,yDAA4D;EAC5D,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,yDAA8D;EAC9D,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,yDAA6D;EAC7D,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,yDAA8D;EAC9D,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,yDAAkE;EAClE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE;IACE,mEAAmE;IACnE,iBAAiB;IACjB;MACE,4BAA4B;IAC9B;;IAEA;MACE,0BAA0B;MAC1B,4BAA4B;IAC9B;IACA;MACE,WAAW;IACb;EACF;AACF;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE;;;;;;;;;;WAUS;AACX;;;EAGE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA,wDAAwD;EACxD;IACE,aAAa;EACf;;EAEA,kEAAkE;EAClE;IACE,aAAa,EAAE,6BAA6B;EAC9C;;;EAGA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,iEAAiE;IACjE,0BAA0B;IAC1B,mCAAmC;EACrC;;;AAGF;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,iEAAiE;IACjE,0BAA0B;IAC1B,mCAAmC;EACrC;AACF;;AAxQA;EAAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,yBCAA;EDAA,yDCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,6BCAA;EDAA,yDCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,gBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,gBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,iKCAA;EDAA,yJCAA;EDAA,kLCAA;EDAA,yDCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,yBCAA;EDAA,yDCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,+BCAA;EDAA,yDCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,iBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,kBCAA;EDAA,kBCAA;EDAA;CCAA;;ADAA;EAAA,kBCAA;EDAA,kBCAA;EDAA;CCAA;;ADAA;EAAA,iBCAA;EDAA,iBCAA;EDAA;CCAA;;ADAA;EAAA,kBCAA;EDAA,kBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,gFCAA;EDAA,oGCAA;EDAA;CCAA;;ADAA;EAAA,8ECAA;EDAA,kGCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,yCCAA;EDAA;CCAA;;ADAA;EAAA,yCCAA;EDAA;CCAA;;ADAA;EAAA,yCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,yCCAA;EDAA;CCAA;;ADAA;EAAA,uCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,yCCAA;EDAA;CCAA;;ADAA;EAAA,yCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,yCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,wCCAA;EDAA;CCAA;;ADAA;EAAA,yCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,gBCAA;EDAA;CCAA;;ADAA;EAAA,kBCAA;EDAA,kBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,kCCAA;EDAA,gDCAA;EDAA;CCAA;;ADAA;EAAA,+BCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,4GCAA;EDAA,0GCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,gBCAA;EDAA,gBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,kCCAA;EDAA,gDCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,kCCAA;EDAA,gDCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,uBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,oBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,oBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,gBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,kCCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA,uBCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,2BCAA;EDAA;CCAA;;ADAA;EAAA,qBCAA;EDAA;CCAA;;ADAA;;EAAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,iBCAA;IDAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,gBCAA;IDAA,gBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,qBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,qBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,gBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;CAAA;;ADAA;;EAAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,qBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,gBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;CAAA;;ADAA;;EAAA;IAAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,iBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,qBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,iBCAA;IDAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,gBCAA;IDAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;CAAA;;ADAA;;EAAA;IAAA,iBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,kBCAA;IDAA;GCAA;;EDAA;IAAA,oBCAA;IDAA;GCAA;;EDAA;IAAA,gBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;CAAA;;ADAA;;EAAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA,mBCAA;IDAA;GCAA;CAAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,4GCAA;EDAA,0GCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA,mBCAA;EDAA;CCAA;;ADAA;EAAA,4GCAA;EDAA,0GCAA;EDAA;CCAA;;ADAA;EAAA;CCAA;;ADAA;EAAA;CCAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n@import url(\"https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap\");\n\n.font-200 {\n  font-weight: 200;\n}\n\n.font-300 {\n  font-weight: 300;\n}\n\n.font-400 {\n  font-weight: 400;\n}\n\n.font-500 {\n  font-weight: 500;\n}\n\n.font-600 {\n  font-weight: 600;\n}\n\n.font-700 {\n  font-weight: 700;\n}\n\n.font-800 {\n  font-weight: 800;\n}\n\n.Splash {\n  background: linear-gradient(to bottom, #888888, #000000, #ffffff);\n}\n\n* {\n  letter-spacing: 1.5% !important;\n  font-family: \"Manrope\", sans-serif !important;\n}\n\n/* index.css */\nbody {\n  /* Set the default scrollbar width and color */\n  font-family: \"Manrope\", sans-serif;\n  color: #1d1d1f;\n  background-color: #fbfbfd;\n  scrollbar-width: thin;\n  scrollbar-color: purple transparent;\n\n  /* Set the width and color of the thumb (the draggable part of the scrollbar) */\n  /* The first color (purple) represents the thumb color, the second (transparent) represents the track color */\n  scrollbar-color: purple transparent;\n}\n\n/* Define the scrollbar styles for WebKit-based browsers */\n/* You can adjust the height and color to your preference */\n/* The first color (purple) represents the thumb color, the second (transparent) represents the track color */\nbody::-webkit-scrollbar {\n  width: 6px; /* Set the width of the scrollbar */\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: purple; /* Set the color of the scrollbar thumb */\n  border-radius: 3px; /* Round the corners of the thumb */\n}\n\nbody::-webkit-scrollbar-thumb:hover {\n  background-color: #a000a0; /* Change the color on hover (optional) */\n}\n\nbody::-webkit-scrollbar-track {\n  background-color: transparent; /* Set the color of the scrollbar track */\n}\n\n.chatbot-scrollbar::-webkit-scrollbar {\n  width: 6px; /* Set the width of the scrollbar */\n}\n\n.chatbot-scrollbar::-webkit-scrollbar-thumb {\n  background-color: purple; /* Set the color of the scrollbar thumb */\n  border-radius: 3px; /* Round the corners of the thumb */\n}\n\n.chatbot-scrollbar::-webkit-scrollbar-thumb:hover {\n  background-color: #a000a0; /* Change the color on hover (optional) */\n}\n\n.form-submit-hover-animations {\n  /* hover:border-b-main hover:border-b-2 hover:rounded-md hover:bg-main  hover:text-white */\n  box-shadow: inset -10.5em 0 0 0 #45115f, inset 10.5em 0 0 0 #45115f;\n  color: #ffffff;\n}\n\n/* .form-submit-hover-animations:hover::after {\n  width: 100%;\n} */\n\n.chatbot-bg {\n  border-radius: 40px;\n  background: linear-gradient(0deg, #eee7f0 0%, #eee7f0 100%), #fff;\n}\n\n.question-bg {\n  border-radius: var(--none, 0px);\n  background: var(--p-purple-80, rgba(69, 17, 95, 0.8));\n}\n\n/* Button */\n\n.button-img-ios,\n.button-img-android {\n  transition: transform 0.3s ease;\n}\n\n.button-img-ios {\n  width: 150px;\n}\n\n.button-img-android {\n  width: 170px;\n}\n\n.button-img-ios:hover,\n.button-img-android:hover {\n  transform: scale(0.95);\n}\n\n.hero-img {\n  background-image: url(\"../public/assets/images/Home.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: bottom right;\n  margin-top: -40px;\n}\n\n.about-img{\n  background-image: url(\"../public/assets/images/about-u.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: bottom right;\n}\n\n.getstarted-img {\n  background-image: url(\"../public/assets/images/Image-Pop.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: bottom right;\n}\n\n.faq-img {\n  background-image: url(\"../public/assets/images/FAQ-Page.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: bottom right;\n}\n\n.contact-img {\n  background-image: url(\"../public/assets/images/Need-Help.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: bottom right;\n}\n\n.getstartedIMG {\n  background-image: url(\"../public/assets/images/bg-getstarted.png\");\n  background-size: cover;\n  /* background-repeat: no-repeat; */\n}\n\n@media (max-width: 1366px) {\n  @screen md {\n    /* Your styles for screens 1366px and below (up to md breakpoint) */\n    /* For example: */\n    .hero-title {\n      font-size: 3.5rem !important;\n    }\n\n    .hero-subtitle {\n      font-size: 24px !important;\n      line-height: 28px !important;\n    }\n    .hero-bg-line {\n      height: 50%;\n    }\n  }\n}\n\n.zoom-in {\n  transform: scale(1.5);\n  transition: transform 0.5s;\n}\n\n.footerSectionBg {\n  background: radial-gradient(\n      647.9% 103.11% at 94.92% 58.65%,\n      rgba(238, 203, 255, 0.12) 0%,\n      rgba(0, 0, 0, 0) 100%\n    ),\n    radial-gradient(\n      230.13% 117.13% at 27.79% 13.14%,\n      rgba(238, 203, 255, 0.12) 0%,\n      rgba(0, 0, 0, 0) 100%\n    ),\n    #45115f;\n}\n\n\n  .scroll-section {\n    position: relative;\n    overflow: hidden;\n  }\n\n  /* Remove any default margin and padding */\n  .scroll-section, .scroll-section * {\n    margin: 0;\n    /* padding: 0; */\n  }\n\n  /* Optional: Remove outline on focus for accessibility */\n  .scroll-section a:focus, .scroll-section button:focus {\n    outline: none;\n  }\n\n  /* Optional: Remove any default browser styles for the scrollbar */\n  .scroll-section::-webkit-scrollbar {\n    display: none; /* Optional: Hide scrollbar */\n  }\n\n\n  .bgContainer{\n    background-color: #fff;\n    height: auto;\n    width: 100%;\n    background-image: linear-gradient(60deg , #fff, #F9EEFF, #F3DCFF);\n    background-size: 400% 400%;\n    animation: animate 2s ease infinite;\n  }\n\n\n@keyframes animate {\n  0% {\n    background-position: 0 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .bgContainer{\n    background-color: #fff;\n    height: auto;\n    width: 100%;\n    background-image: linear-gradient(60deg , #fff, #F9EEFF, #F3DCFF);\n    background-size: 400% 400%;\n    animation: animate 2s ease infinite;\n  }\n}\n\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
